import { GlobalneVarijableProvider } from 'hooks/useGlobalneVarijable';
import React from 'react';
import {RouterProvider} from "react-router";
import Router from "./routers/Router";
import {GrupaRobaProvider} from "./context/GrupaRobaContext";


function App() {
    return <GlobalneVarijableProvider>
        <GrupaRobaProvider>
        <RouterProvider router={Router} />
        </GrupaRobaProvider>
        </GlobalneVarijableProvider>;
}

export default App;
